import { useState, useEffect } from 'react';
import _ from 'lodash';

export function useScroll() {
  const [scroll, setScroll] = useState({
    y: 0,
    direction: 'up',
  });
  const listener = (e) => {
    setScroll((prev) => ({
      y: Math.abs(document.body.getBoundingClientRect().top),
      direction:
        prev.y > Math.abs(document.body.getBoundingClientRect().top)
          ? 'up'
          : 'down',
    }));
  };

  useEffect(() => {
    const debouncedListener = _.debounce(listener, 50);
    window.addEventListener('scroll', debouncedListener);
    return () => window.removeEventListener('scroll', debouncedListener);
  }, []);

  return scroll;
}
